import { useTheme as useJssTheme } from 'react-jss';
import type { ThemeType } from './jssTypes';

export const useTheme = (): ThemeType => {
  return useJssTheme<ThemeType>();
};

export default useTheme;
